import { render, staticRenderFns } from "./EditFeedbackRequestStatus.vue?vue&type=template&id=083ea269&"
import script from "./EditFeedbackRequestStatus.vue?vue&type=script&lang=js&"
export * from "./EditFeedbackRequestStatus.vue?vue&type=script&lang=js&"
import style0 from "./EditFeedbackRequestStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports